<template>
  <div>
    <!----------------- Main contents Area --------------------->
    <!-- mt-3: margin top-3 -->
    <main class="mt-3">
      <div class="p-1 text-center">
        <div class="mb-4">
          <h3 class="text-start px-5"><i class="bi bi-megaphone-fill text-info"></i>&nbsp;&nbsp;공 지 사 항 관 리</h3>
        </div>
        <div class="mb-2">
          <table style="border: 1px solid rgba(0, 0, 0, 0.3); width: 30%; height: 100px;;">
            <tr style="text-align: left;">
              <td style="vertical-align: middle; padding-left: 20px;">
                <div class="input-group mb-3">
                  <input type="text" class="form form-control-sm" v-model="nTitle" style="width: 400px;" placeholder="검색할 공지제목">
                  <button class="btn btn-success btn-sm" @click="getNoticeList(nTitle)">제목검색</button>
                </div>
                <div class="input-group">
                  <select class="form form-select-sm" style="width: 400px;" v-model="nCategory">
                    <option value="">전체공지분류</option>
                    <option value="NT">[NT] 공지</option>
                    <option value="EV">[EV] 이벤트</option>
                    <option value="TR">[TR] 여행관련</option>
                    <option value="MO">[MO] 항공선박</option>
                    <option value="PR">[PR] 홍보/안내</option>
                    <!-- <option value="ET">[ET] 기타</option> -->
                  </select>
                  <button class="btn btn-info btn-sm" @click="getNoticeListByCategory(nCategory)">카테고리검색</button>
                </div>
              </td>
            </tr>
          </table>
        </div>

        <div class="float-end mb-1">
          <button type="button" class="btn btn-md btn-primary" @click="goToInsert()">공지등록</button>&nbsp;&nbsp;
          <button type="button" class="btn btn-sm btn-outline-secondary" @click="updNoticeFlag('F')">고정공지(3개 이내)</button>
        </div>
        <table class="table table-bordered table-striped fs-6">
          <thead class = "small">
            <tr>
              <th style="width: 2%;">
                <input class="form-check-input" type="checkbox" v-model="allSelected" @change="allChoice()" />
              </th>
              <th style="width: 3%">고정공지</th>
              <th style="width: 4%">팝업공지</th>
              <th style="width: 6%">공지분류</th>
              <th style="width: 25%">공지제목</th>
              <th style="width: 8%">작성일</th>
              <th style="width: 3%">썸네일</th>
              <th style="width: 5%">공지표시</th>
              <!-- <th style="width: 8%">게시기간</th> -->
              <th style="width: 8%">팝업기간</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="i" v-for="(notice, i) in noticeList">
              <td>
                <input type="checkbox" v-model="notice.checkFlag"  ref="chb_noticeSeq" style="vertical-align: middle;">
              </td>

              <td v-if="notice.fixedFlag === 'Y'">Y</td>
              <td v-else></td>

              <td v-if="notice.popupFlag === 'Y'">
                <button class="btn btn-sm btn-success" @click="makePopup('N', notice.noticeCode)">팝업</button>
              </td>
              <td v-else>
                <button class="btn btn-sm btn-outline-success" @click="makePopup('Y', notice.noticeCode)">팝업</button>
              </td>

              <td>
                <div v-if="notice.ctCd === 'NT'">공지</div>
                <div v-else-if="notice.ctCd === 'EV'">이벤트</div>
                <div v-else-if="notice.ctCd === 'TR'">여행관련</div>
                <div v-else-if="notice.ctCd === 'MO'">항공선박</div>
                <div v-else-if="notice.ctCd === 'PR'">홍보/안내</div>
                <div v-else>기타</div>
              </td>

              <td style="text-align: start; padding-left: 10px; vertical-align: middle;">
                <a @click="goToNoticeDetail(notice.noticeCode, notice.ctCd);" style="cursor:pointer;"><span class="text-primary">{{ notice.nTitle }}</span></a>
              </td>
              <td>
                <div style="display: flex; align-items: center; gap: 4px;">
                  <input type="date" class="form-control form-control-sm text-success" style="font-size: small; width: 130px;" v-model="notice.nDate">
                  <button type="button" class="btn btn-outline-success btn-sm" @click="changeNoticeDate(notice.noticeCode, notice.nDate)">변경</button>
                </div>
              </td>
              <td>{{ notice.thumbNail }}</td>
              <td>
                <button type="button" class="btn btn-warning btn-sm" v-if="notice.nUseFlag === 'Y'" @click="changeStatus(notice.nUseFlag, notice.seqNotice)">표시</button>
                <button type="button" class="btn btn-outline-warning btn-sm" v-else @click="changeStatus(notice.nUseFlag, notice.seqNotice)">비표시</button>
              </td>

              <!-- 게시기간 -->
              <!-- <td v-if="notice.nFrom != '' && notice.nTo != ''">
                {{ getDateFormat(notice.nFrom) }} ~ {{ getDateFormat(notice.nTo) }}
              </td>
              <td v-else>
              </td> -->

              <!-- 팝업기간 -->
              <td class="text-danger" v-if="notice.pFrom != null && notice.pTo != null">
                {{ getDateFormat(notice.pFrom) }} ~ {{ getDateFormat(notice.pTo) }}
              </td>
              <td v-else></td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>
  </div>
</template>

<script>
//import moment from 'moment';
export default {
  // DB에서 가져온 데이타
  data() {
    return {
      //productMaList: [],
      noticeList: [],
      companyInfo: [],

      allSelected: "N",        //전체체크여부

      nTitle: "",              //공지제목검색

    };
  },
  created() {
    this.user = this.$store.state.user;
    this.getNoticeList();
  }, 
  // filters: {
  //   currency: function(val) {
  //     var num = new Number(val);
  //     return num.toFixed(0).replacereplace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //   }
  // },
  computed: {
    user() {
      return this.$store.state.user;
    }    
  },
  mounted() {
    // if(document.referrer == "") {
    //   this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
    //   location.replace("/")
    // }
    //권한없는 로그인 차단
    if(this.user.handlerGrade >= 20 || this.user.handlerId == undefined) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/b2bLogin'});
    }
    //document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";    
  },
  methods: {
    // 게시등록일 사후변경
    async changeNoticeDate(nCode, nDate) {
      alert(nCode + "//" + nDate)
      let res = await this.$api("/api/upd_noticeInsDate", {param: [nDate, nCode]})

      if(res.affectedRows > 0)
      {
        this.$swal.fire('', '공지작성일 변경완료', 'success').then(() => {
          // 상태변경 후, 갱신
          this.getNoticeList();
        });
      }
      else 
      {
        this.$swal.fire('', '공지작성일 변경 중 오류가 발생했습니다.', 'error');
        return false;
      }
    },

    async makePopup(flag, nCode) {
      this.popupFlag = flag;

      if(flag === "Y") 
      {
        const { value: formValues } = await this.$swal.fire({
          title: '팝업 기간 설정',
          html:
            '<label>시작일:</label> <input id="startDate" type="date" class="swal2-input" style="font-size: small;"> <br> <label>종료일:</label> <input id="endDate" type="date" class="swal2-input" style="font-size: small;">',
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: '확인',
          cancelButtonText: '취소',
          didOpen: () => {
            const today = new Date().toISOString().split("T")[0];
            let startInput = this.$swal.getPopup().querySelector('#startDate');
            let endInput = this.$swal.getPopup().querySelector('#endDate');

            startInput.min = today;
            endInput.min = today;
          },
          preConfirm: () => {
            let startDate = document.getElementById('startDate').value;
            let endDate = document.getElementById('endDate').value;

            if (!startDate || !endDate) {
              this.$swal.showValidationMessage('시작일과 종료일을 모두 입력하세요.');
              return false;
            }

            if (startDate > endDate) {
              this.$swal.showValidationMessage('종료일은 시작일 이후여야 합니다.');
              return false;
            }

            return { startDate, endDate };
          }
        });

        if (formValues) 
        {
          let res_checkDuupNoticePopup = await this.$api("/api/checkDuupNoticePopup", {param: [
            formValues.startDate, formValues.endDate, formValues.startDate, formValues.endDate, formValues.startDate, formValues.endDate
          ]});
          
          if (res_checkDuupNoticePopup.length > 0) 
          {
            // nTitle 항목을 li 형태로 변환
            const titleList = res_checkDuupNoticePopup
              .map(item => `<li>${item.dubPopup}</li>`)
              .join("");

            await this.$swal.fire({
              icon: "warning",
              title: "팝업기간중복",
              html: `<p>아래 팝업과 기간이 겹칩니다:</p><ul style="text-align:left;">${titleList}</ul>`,
              confirmButtonText: "확인"
            });

            return false;
          }
          else
          {
            let res_checkDuupNoticePopup = await this.$api("/api/changeNoticePopup", {param: 
            [
              this.popupFlag, formValues.startDate, formValues.endDate, nCode
            ]
            });
            if(res_checkDuupNoticePopup.affectedRows > 0)
            {
              this.$swal.fire(
                '팝업기간 설정 완료',
                `시작일: ${formValues.startDate}\n종료일: ${formValues.endDate}`,
                'success'
              ).then(() => {
                // 상태변경 후, 갱신
                this.getNoticeList();
              });
            }
            else 
            {
              this.$swal.fire('', '팝업기간 설정 중 오류가 발생했습니다.', 'error');
              return false;
            }
          }
        }
      }
      else 
      {
        this.$swal.fire({
          html: '팝업해제를 진행하시겠습니까?',
          showCancelButton: true,
          confirmButtonText: '네',
          cancelButtonText: '아니오',
        }).then(async (result) => {
          if (result.isConfirmed) 
          {
            let popupFlag = 'N'
            let pFrom = null
            let pTo = null
            let res_checkDuupNoticePopup = await this.$api("/api/changeNoticePopup", {param: [popupFlag, pFrom, pTo, nCode ]});

            if(res_checkDuupNoticePopup.affectedRows > 0)
            {
              this.$swal.fire('', '팝업해제완료','success').then(() => {
                // 상태변경 후, 갱신
                this.getNoticeList();
              });
            }
            else 
            {
              this.$swal.fire('', '팝업해제 중 오류가 발생했습니다.', 'error');
              return false;
            }
          }
        })        
      }
    },


    //공지내 바로가기 링크
    // async setLink(linkFlag,noticeCode,link)
    // {
    //   let linkFlag1 = ""
    //   //let badge = "1 + 1"
    //   if(linkFlag != 'Y' && linkFlag != 'N')
    //   {
    //     linkFlag1 = "N"
    //   }
    //   else
    //   {
    //     linkFlag1 = linkFlag
    //   }

    //   if(linkFlag1 =="Y")
    //   {
    //     this.$swal.fire({
    //       html: '바로가기의 속성(설정<->해제)을 변경합니까?',
    //       showCancelButton: true,
    //       confirmButtonText: '네',
    //       cancelButtonText: '아니오',
    //     }).then(async (result) => {
    //       /* Read more about isConfirmed, isDenied below */
    //       if (result.isConfirmed) {
    //         //let cStatus = (badgeFlag1 === "Y") ? "N" : "Y"
    //         let cStatus = 'N'
    //         //console.log("param:",cStatus, pdtCode);
    //         await this.$api("/api/changeNoticeFlagStatus", {param: [cStatus, link, noticeCode ]});
    //         // 상태변경 후, 갱신
    //         this.getNoticeList();
    //         this.$swal.fire('', '변경완료', 'success')
    //       }
    //     })
    //   }
    //   else
    //   {
    //     const { value: linkTxt } = await this.$swal.fire({
    //       html: '이동할 페이지의 주소창의 정보를 입력하세요(copy & paste)',
    //       input: 'text',
    //       //inputLabel: '뱃지표시',
    //       inputPlaceholder: link
    //     })

    //     //console.log("linkTxt:",linkTxt,"//badge:",badge)

    //     if (linkTxt) {
    //       this.$swal.fire('',`이동할 페이지주소: ${linkTxt}`)
    //       let cStatus = 'Y'
    //       await this.$api("/api/changeNoticeFlagStatus", {param: [cStatus, linkTxt, noticeCode ]});
    //       // 상태변경 후, 갱신
    //       this.getNoticeList();
    //       this.$swal.fire('', '생성완료', 'success')
    //     }
    //   }
    // },

    allChoice() 
    {
      if(this.allSelected)
      {
        this.noticeList.forEach((notice) => {
          notice.checkFlag = true;
        })
      }
      else
      {
        this.noticeList.forEach((notice) => {
          notice.checkFlag = false;
        })
      }
    },

    //선택된 공지의 상태변경
    async updNoticeFlag(flag)
    {
      let selectedNotice = [];
      this.noticeList.forEach((notice) => {
        if(notice.checkFlag)
        {
          selectedNotice.push(notice.noticeCode)
        }
      })
      //console.log("selectedNotice:",selectedNotice)
      //비표시처리
      if(flag === "D")
      {
        this.$swal.fire({
        html: '선택한 공지를 삭제합니까?',
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오'
        }).then(async (result) => {
          if (result.isConfirmed) 
          {
            let i = 0;
            let res = "";
            while(i < selectedNotice.length)
            {
              let hideNotice = await this.$api("/api/hideNotice", {param: [ 'N',selectedNotice[i]]});
              if(hideNotice.affectedRows < 0 || hideNotice.affectedRows === undefined)
              {
                res = "error"
                break;
              }
              i++;
            }
            if(res == "error")
            {
              this.$swal.fire("","삭제 중 에러가 발생했습니다.","error");
              return false;          
            }
            else
            {
              location.reload(true)
            }
          } 
        });
      }
      //상단고정(3개까지)
      else if(flag === "F")
      {
        if(selectedNotice.length> 3)
        {
          this.$swal.fire("","상단고정은 3개까지 입니다","warning");
          return false;
        }
        else
        {
          this.$swal.fire({
          html: '선택한 공지를 상단고정공지로 지정합니까?<br>지정되지 않은 공지들은 일반공지가 됩니다.',
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오'
          }).then(async (result) => {
            if (result.isConfirmed) 
            {
              let makeFixedNotice = await this.$api("/api/makeFixedNotice", {param: [
                selectedNotice[0], selectedNotice[1], selectedNotice[2]
              ]});
              //console.log("makeFixedNotice:",makeFixedNotice)
              if(makeFixedNotice.affectedRows < 0 || makeFixedNotice.affectedRows === undefined)
              {
                this.$swal.fire("","설정 중 에러가 발생했습니다.","error");
                return false;          
              }
              else
              {
                location.reload(true)
              }
            } 
          });          
        }
      }
      
      //홍보안내 고정(2개)
      else if(flag === "P")
      {
        //선택된 공지코드가 이벤트 또는 홍보/안내로만 구성되어 있는지 체크
        let checkCodes = selectedNotice.filter(nCode => !nCode.startsWith("EV") && !nCode.startsWith("PR"))
        
        if(selectedNotice.length> 2)
        {
          this.$swal.fire("","이벤트 또는 홍보/안내의 고정은 2개까지 입니다","warning");
          return false;
        }
        else if(checkCodes.length > 0)
        {
          this.$swal.fire("","이벤트 또는 홍보/안내만 선택가능합니다","warning");
          return false;
        }
        else
        {
          this.$swal.fire({
          html: '선택된 내용은 고정표시됩니다. 진행하시겠습니까?',
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오'
          }).then(async (result) => {
            if (result.isConfirmed) 
            {
              let makeFixedPR = await this.$api("/api/makeFixedPR", {param: [
                selectedNotice[0], selectedNotice[1]
              ]});
              //console.log("makeFixedPR:",makeFixedPR)
              if(makeFixedPR.affectedRows < 0 || makeFixedPR.affectedRows === undefined)
              {
                this.$swal.fire("","설정 중 에러가 발생했습니다.","error");
                return false;          
              }
              else
              {
                location.reload(true)
              }
            } 
          });          
        }
      }      
    },
    getDateFormat(date) {
      return this.$dateFormat(date);
    },

    //공지분류별 조회
    async getNoticeListByCategory(sParam) {
      this.nTitle = ""
      let noticeList = []
      if(sParam != "" && sParam != null && sParam != undefined) {
        noticeList = await this.$api("/api/noticeListForAdminByCategory", {param: [sParam]});
      }
      else 
      {
        noticeList = await this.$api("/api/noticeListForAdmin", {});
      }

      if(noticeList.length > 0) {
        this.noticeList = noticeList;
      }
      else {
        this.$swal.fire('', '등록된 공지가 없습니다.', 'info');
      }
    },
    
    async getNoticeList(sTitle) {
      this.nCategory = ""
      let noticeList = []
      if(sTitle != "" && sTitle != null && sTitle != undefined) {
        noticeList = await this.$api("/api/noticeListForAdminByKeyword", {param: [sTitle]});
      }
      else 
      {
        noticeList = await this.$api("/api/noticeListForAdmin", {});
      }

      if(noticeList.length > 0) 
      {
        this.noticeList = noticeList;

        let i = 0
        while(noticeList.length > i) 
        {
          this.noticeList[i].nDate = this.getDateFormat(noticeList[i].insDate)
          i++;
        }
      }
      else 
      {
        this.$swal.fire('', '등록된 공지가 없습니다.', 'info');
      }
    },
    
    goToInsert() {
      this.$router.push({path: '/noticeCreate'});
    },
    goToNoticeDetail(seqNotice, ctCd) {
      this.$router.push({path: '/noticeDetail', query: {seqNotice: seqNotice, ctCd: ctCd}});
      //console.log("oId:", orderId);
    },
    // mixins에 있는 공통함수 호출샘플
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    // goToImgInsert(pdtCode) {
    //   // 이미지 저장패스
    //   this.$router.push({path: '/image_insert', query: {productId: pdtCode}});
    // },
    // goToUpdate(pdtCode, salesRouet) {
    //   // 이미지 저장패스
    //   this.$router.push({path: '/update', query: {productId: pdtCode, salesRoute: salesRouet}});
    // },
    changeStatus(nUseFlag, seqNotice) {
      //console.log(nUseFlag,"/",seqNotice);
      //변경전 확인
      this.$swal.fire({
        title: '공지표시(표시<->비표시)변경?',
        showCancelButton: true,
        confirmButtonText: '변경',
        cancelButtonText: '취소',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let nStatus = (nUseFlag == "Y") ? "N" : "Y"
          await this.$api("/api/changeNoticeStatus", {param: [nStatus, seqNotice]});
          // 상태변경 후, 갱신
          this.getNoticeList();
          this.$swal.fire('변경완료!', '', 'success')
        }
      })
    }
  }
}
</script>